export const liveRoomsData = [
  {
    id: "1",
    title: "Даф Йоми - Трактат Бава Меция",
    host: "Рав Моше Левин",
    listeners: 47,
    topic: "Гемара",
    startedAt: "2024-11-12T18:30:00",
    language: "Русский",
  },
  {
    id: "2",
    title: "Парашат недели - Ваера",
    host: "Рав Давид Коэн",
    listeners: 32,
    topic: "Тора",
    startedAt: "2024-11-12T19:00:00",
    language: "Иврит",
  },
  {
    id: "3",
    title: "Вопросы и ответы по алахе",
    host: "Рав Ицхак Соломон",
    listeners: 28,
    topic: "Алаха",
    startedAt: "2024-11-12T17:45:00",
    language: "Русский",
  },
  {
    id: "4",
    title: "Хасидут и каббала",
    host: "Рав Шмуэль Гольдштейн",
    listeners: 19,
    topic: "Хасидут",
    startedAt: "2024-11-12T18:15:00",
    language: "Русский",
  },
  {
    id: "5",
    title: "Мишна Йоми - Трактат Брахот",
    host: "Рав Йосеф Фридман",
    listeners: 35,
    topic: "Мишна",
    startedAt: "2024-11-12T19:30:00",
    language: "Русский",
  },
  {
    id: "6",
    title: "Законы кашрута - практические вопросы",
    host: "Рав Элиэзер Розенберг",
    listeners: 24,
    topic: "Алаха",
    startedAt: "2024-11-12T18:00:00",
    language: "Русский",
  },
  {
    id: "7",
    title: "Комментарии Раши к недельной главе",
    host: "Рав Биньямин Кац",
    listeners: 41,
    topic: "Тора",
    startedAt: "2024-11-12T19:15:00",
    language: "Иврит",
  },
  {
    id: "8",
    title: "Учение Ребе - Ликутей Сихот",
    host: "Рав Менахем Мендель Шварц",
    listeners: 52,
    topic: "Хасидут",
    startedAt: "2024-11-12T18:45:00",
    language: "Русский",
  },
  {
    id: "9",
    title: "Талмуд - Трактат Шаббат",
    host: "Рав Шимон Грин",
    listeners: 38,
    topic: "Гемара",
    startedAt: "2024-11-12T17:30:00",
    language: "Русский",
  },
  {
    id: "10",
    title: "Мусар - этика и мораль",
    host: "Рав Аарон Левин",
    listeners: 29,
    topic: "Мусар",
    startedAt: "2024-11-12T20:00:00",
    language: "Русский",
  },
  {
    id: "11",
    title: "Законы праздников - Суккот",
    host: "Рав Цви Вайс",
    listeners: 33,
    topic: "Алаха",
    startedAt: "2024-11-12T18:20:00",
    language: "Иврит",
  },
  {
    id: "12",
    title: "Изучение Тании - ежедневный урок",
    host: "Рав Дов Бер Шнеерсон",
    listeners: 45,
    topic: "Хасидут",
    startedAt: "2024-11-12T19:45:00",
    language: "Русский",
  },
];
